import React, { useEffect, useState } from "react";
import { updateCareTeamStatus } from "../../services/CareTeam";
import { showToastError, showToastSuccess } from "../../Utils/Helper";
import { useAuth } from "../../Context/AuthContext";

const CareTeamStatus = ({ teamData }) => {
  const { isAdmin } = useAuth();
  const provider = JSON.parse(localStorage.getItem("user_id"));
  const [status, setStatus] = useState()
  

  useEffect(()=>{
    setStatus(teamData?.status)
  }, [])

  console.log(!isAdmin ,provider !== teamData?.teamManager,provider !== teamData?.createdBy)

  const validateUser = () => {
    const validuser = (isAdmin === false && (teamData?.teamManager === provider) === false && (provider === teamData?.createdBy) === false) ? true : false
    return validuser
  }

  const handleCareTeamStatus = async () => {
    try {
      if (validateUser()) {
        showToastError('no access')
        return;
      } 
      const response = await updateCareTeamStatus(teamData?._id);
      if (response.status !== 200) {
        showToastError("something went wrong");
        return;
      }
      setStatus(!status)
      showToastSuccess("Status updated");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="careteamstatus mt-4 text-center pt-4 pb-3">
        <p className="setstatus_team mt-2">Set status of care team group</p>
        <p className="careteam_switchtext">
          Active
          <label class="switch ms-4 me-4">
            <input
              type="checkbox"
              checked={!status}
              onChange={(e) => handleCareTeamStatus(e.target.checked)}
            />
            <span class="slider round"></span>
          </label>
          In-active
        </p>
      </div>
    </>
  );
};

export default CareTeamStatus;
